import { format } from 'date-fns'

/**
 * Дата из локальной базы кассы.
 *
 * Отличается от helpers/formatDate тем, что не падает: сюда прилетает то, что
 * лежит в чужой базе, и на старой версии кассы в колонке может оказаться что
 * угодно, вплоть до пустой строки. Уронить весь монитор из-за одной ячейки
 * нельзя — он для того и нужен, чтобы посмотреть, что там лежит.
 */
export function formatPosDate(value, pattern = 'dd.MM.yyyy HH:mm') {
	if (value === null || value === undefined || value === '') return '—'

	const date = value instanceof Date ? value : new Date(value)
	if (Number.isNaN(date.getTime())) return String(value)

	return format(date, pattern)
}

/** Значение произвольной колонки в ячейку таблицы. */
export function renderCell(value) {
	if (value === null || value === undefined) return ''
	if (typeof value === 'object') return JSON.stringify(value)
	if (typeof value === 'boolean') return value ? 'true' : 'false'

	return String(value)
}

export function prettyJson(value) {
	try {
		return JSON.stringify(value, null, 2)
	} catch (error) {
		return String(value)
	}
}
